'use strict';
function blurOnClick(element) {
	// Prevent focus state behaving differently in chrome
	element[0].addEventListener('click', () => {
		element[0].blur();
	});
}

function link(scope, element, attr) {
	element.addClass('pmt-btn');

	if (element[0].tagName === 'BUTTON' && !angular.isDefined(attr.type)) {
		element[0].setAttribute('type', 'button');
	}

	function setProgressState(inProgress) {
		element[0].disabled = inProgress;
		if (inProgress) {
			element.addClass('pmt-btn--progress');
		} else {
			element.removeClass('pmt-btn--progress');
		}
	}

	if (angular.isDefined(scope.pmtBtnProgress)) {
		scope.$watch('pmtBtnProgress', setProgressState);
		setProgressState();
	}
}

angular
	.module('PinMeTo.UI')
	.directive('pmtBtn', () => ({
		restrict: 'A',
		scope: {
			pmtBtnProgress: '<'
		},
		transclude: true,
		template:
			'<span class="pmt-btn__label" ng-transclude></span><pmt-spinner class="pmt-btn__spinner" ng-if="pmtBtnProgress"></pmt-spinner>',
		link: (scope, element, attr) => {
			if (angular.isDefined(attr.pmtBtnSmall)) {
				element.addClass('pmt-btn--link');

				if (angular.isDefined(attr.pmtBtnNegative)) {
					element.addClass('pmt-btn--brand-4');
				}
			} else {
				element.addClass('pmt-btn--default');

				if (angular.isDefined(attr.pmtBtnNegative) && !angular.isDefined(attr.pmtBtnSecondary)) {
					element.addClass('pmt-btn--brand-4');
				} else if (
					!angular.isDefined(attr.pmtBtnNegative) &&
					angular.isDefined(attr.pmtBtnSecondary)
				) {
					element.addClass('pmt-btn--brand-2');
				}
			}

			blurOnClick(element);

			return link(scope, element, attr);
		}
	}))
	.directive('pmtBtnPlain', () => ({
		restrict: 'A',
		scope: {
			pmtBtnProgress: '<',
			pmtBtnStyleLight: '<'
		},
		transclude: true,
		template:
			'<span class="pmt-btn__label" ng-transclude></span><pmt-spinner class="pmt-btn__spinner" ng-if="pmtBtnProgress"></pmt-spinner>',
		link: (scope, element, attr) => {
			element.addClass('pmt-btn--plain');

			if (angular.isDefined(attr.pmtBtnLight) || scope.pmtBtnStyleLight === true) {
				element.addClass('pmt-btn--light');
			}

			return link(scope, element, attr);
		}
	}))
	.directive('pmtBtnCta', () => ({
		restrict: 'A',
		scope: {
			pmtBtnProgress: '<'
		},
		transclude: {
			icon: 'pmtBtnIcon'
		},
		template:
			'<span class="pmt-btn__icon" aria-hidden="true" ng-transclude="icon"></span><span class="pmt-btn__label" ng-transclude></span><pmt-spinner class="pmt-btn__spinner" ng-if="pmtBtnProgress"></pmt-spinner>',
		link: (scope, element, attr) => {
			element.addClass('pmt-btn--with-icon');

			if (angular.isDefined(attr.pmtBtnSmall)) {
				element.addClass('pmt-btn--link');

				if (angular.isDefined(attr.pmtBtnNegative)) {
					element.addClass('pmt-btn--brand-4');
				}
			} else {
				element.addClass('pmt-btn--default');
			}

			blurOnClick(element);

			return link(scope, element, attr);
		}
	}));
